module.exports = __webpack_public_path__ + "static/media/la.bdfc4ab5.svg";